<template>

  <div id="progressionBody" class="flexwrap">
    <!--
    <div @click="isGold = !isGold" :class="{'isActive' : isGold}">Gold</div>
    <div @click="isSilver = !isSilver" :class="{'isActive' : isSilver}">Silver</div>
    <div @click="isBronze = !isBronze" :class="{'isActive' : isBronze}">Bronze</div>
    -->
    <!--<div @click="newest = !newest" :class="{'isActive' : newest}">+ récents</div>-->
    <transition name="fade" mode="out-in" appear>
      <div v-if="dataLoaded.user" :key="dataLoaded.user" class="progressionStats">
        <div id="progressionHead">
          <div id="profilepic" class="mediumShadow" style="grid-column: 1/2; grid-row: 1/2"
               :style="{ backgroundImage: 'url(' + profile.picture + ')'}">
            <div>
              <div v-if="profile.datas.is_premium" id="premiumIconProgression" class="flexwrap centercenter">
                <i class="fas fa-burn"></i>
              </div>
            </div>
          </div>
          <div class="softTextShadow"  style="grid-column: 2/3; grid-row: 1/2; text-decoration: none; ">
            <h1 :key="mainLevel">Niveau {{mainLevel+1}}
              <!--<animated-number :number="mainLevel+1"></animated-number>-->
            </h1>
            <progress-bar-step  :key="percentsCompleted" :value="percentsCompleted*1000" class="plainStandardTheme"
                                :withoutColor="true"
            ></progress-bar-step>
            <span class="softTextShadow" :key="pointToLevelUp" style="font-size: 1.2em">
              <!--<animated-number :number="pointToLevelUp"></animated-number>-->
              {{pointToLevelUp}}pts pour le suivant</span>
          </div>

          <div class="flexwrap centercenter" style="grid-column: 1/3;">
            <div v-if="currentSeason.loaded && currentSeason.id !== profile.datas.ongoing_season_obj.id" class="flexwrap centercenter progressionBubble poster textShadow clickable mediumShadow"
                  :style="{ backgroundImage: getBackground(profile.datas.ongoing_show_obj.poster_path)}"
                  @click="set_seasonRequested(profile.datas.ongoing_season_obj.id)"
                  v-tooltip="profile.datas.ongoing_show_obj.english_title+(showsData[seasonsData[profile.datas.ongoing_season_obj.id].show_id].seasons.length>1?' '+seasonsData[profile.datas.ongoing_season_obj.id].english_title:'')">
            </div>

            <div v-tooltip="'Nombre de points accumulés'" class="flexwrap centercenter progressionBubble mediumShadow" style="background-color: var(--learnColor2);">
              <span style="font-size: 1.4em; margin-top: 0.3vw">{{profile.datas.points}}</span>
              <span style="margin-top: -0.3vw">pts</span>

            </div>
            <div v-tooltip="'Durée des dialogues suivis cumulés'" class="flexwrap centercenter progressionBubble mediumShadow" style="background-color: var(--watchColor2);">

              <span style="font-size: 1.4em; margin-top: 0.3vw">{{getHours(totalDuration)!=0?getHours(totalDuration)+'h':getMinutes(totalDuration)+'m'}}</span>
              <span style="margin-top: -0.3vw" v-if="getHours(totalDuration)!=0">{{getMinutes(totalDuration)}}m</span>

            </div>
            <div class="flexwrap centercenter" style="flex-direction: column;">

              <div v-tooltip="'Mots connus (or)'" class="flexwrap centercenter progressionLevels mediumShadow" style="background-color: var(--goldDarkBackground); color: var(--goldDarkColor);">{{level_gold}}</div>
              <div v-tooltip="'Mots revus (argent)'"  class="flexwrap centercenter progressionLevels mediumShadow" style="background-color: var(--silverDarkBackground); color: var(--silverDarkColor);">{{level_silver}}</div>
              <div v-tooltip="'Mots vus (bronze)'"  class="flexwrap centercenter progressionLevels mediumShadow" style="background-color: var(--copperDarkBackground); color: var(--copperDarkColor);">{{level_copper}}</div>
            </div>

          </div>
        </div>
        <div>
          <h2 class="softTextShadow"><i class="far fa-calendar-day"></i> Mon objectif</h2>
          <goal class="paddingLeft"></goal>
          <div class="flexwrap paddingLeft">

            <div class="flexwrap centercenter">
              <div class="flexwrap centercenter progressionBubble bubble2 mediumShadow" style="background-color: var(--goalBackgroundColor)">
                  <span style="font-size: 2em; padding-top: 0.3vw">
                    {{profile.datas.current_week_streak}}
                  </span>
              </div>
              <h2 class="softTextShadow" style="margin-top: 0.5vw; font-size: 1.2em">{{'semaine'+(profile.datas.current_week_streak>1?'s':'')}}<br/>consecutive{{(profile.datas.current_week_streak>1?'s':'')}}</h2>
            </div>
          </div>
        </div>
        <!--<div class="flexwrap" id="progressionOngoing">
          <h2 class="softTextShadow"><i class="fas fa-sync-alt"></i> Ma saison en cours</h2>
          <div v-if="ongoingSeason!=null" class="plainTheme mediumShadow clickable mediumRoundAngles currentShowColor paddingLeft"
               id="progressionOngoingBody"
               :style="styleObject(showsData[seasonsData[this.profile.datas.user_seasons[0].season_id].show_id])"
               @click="selected(ongoingSeason.season_id)">
            <lazy-background
                :src="'https://learnandwatch.s3.eu-west-3.amazonaws.com/blur3/' + showsData[seasonsData[ongoingSeason.season_id].show_id].background_path"
                style="width: 100%;"
                :placeholder='require("../assets/placeholder.png")' position="bottom">

              <div slot="content" class="vignettecontent flexwrap centercenter" style="flex-direction: column;">
                <h3 style="font-size: 1.5em; font-weight: bold; overflow: visible" class="line-clamp clamp1 textShadow">{{showsData[seasonsData[ongoingSeason.season_id].show_id].english_title}}</h3>
                <h3 style="font-weight: bold; overflow: visible" v-if="showsData[seasonsData[ongoingSeason.season_id].show_id].seasons.length>1" class="line-clamp clamp1 textShadow" >{{seasonsData[ongoingSeason.season_id].english_title}}</h3>
                <div class="flexwrap" style="grid-column: 1/3">

                  <div class="centercenter progressionBubble bubble2" style="display:flex; flex-direction: column; background-color: white; opacity: 0.4; color: black">
                    <span style="font-size: 1.2em; margin-top: 0.3vw">{{ongoingSeason.nb_episodes_completed}}</span>
                    <span style="border-top: 2px black solid">{{ongoingSeason.nb_episodes}}</span>
                  </div>
                  <div class="centercenter progressionBubble bubble2" style="display:flex; flex-direction: column; background-color: white; opacity: 0.4; color: black">
                    <span style="font-size: 1.2em; margin-top: 0.2vw">{{ongoingSeason.points}}</span>
                    <span style="margin-top: -0.3vw">pts</span>
                  </div>
                  <div class="centercenter progressionBubble bubble2" style="display:flex; flex-direction: column; background-color: white; opacity: 0.4; color: black">
                    <div class="flexwrap centercenter" style="width: calc(100% - 0.5vw); padding:0 0.25vw 0 0.25vw">
                      <span style="font-size: 1.2em; margin-top: 0.2vw" v-if="getHours(ongoingSeason.duration)!=0">{{getHours(ongoingSeason.duration)}}h</span>
                      <span style="margin-top: -0.3vw">{{getMinutes(ongoingSeason.duration)}}m</span>
                    </div>

                  </div>
                </div>
              </div>
            </lazy-background>


          </div>
          <div v-else><h3 class="clickable" @click="set_navOpened(true)">Démarre une saison pour la voir apparaitre ici!</h3></div>

        </div>-->
          <badges
              :newbie="newbie"
              :totalEpisodes="totalEpisodes"
              @selected="selected"
          ></badges>

        </div>


    <loading-logo :key="dataLoaded.user" v-else></loading-logo>
  </transition>

  </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {lock} from "@/main";
import axios from "axios";
import {API_URL} from "@/App";

export default {
  name: "progression",
  components: {
    Badges: () => import(/* webpackPrefetch: true */ '@/components/badges.vue'),
    ProgressBarStep: () => import(/* webpackPrefetch: true */ '@/components/progressBarStep.vue'),
    Goal: () => import(/* webpackPrefetch: true */ '@/components/goal.vue'),
    LoadingLogo: () => import(/* webpackPrefetch: true */ '@/components/loadingLogo.vue')
  },
  created: function(){
    if(this.fullWordsLearnt.length === 0) {
      this.loadFullWordsLearnt();
    }
    else {
      this.loaded = true;
    }
  },
  computed: {
    ...mapGetters('global', [
        'isMobile',
      'dataLoaded',
      'fullWordsLearnt',
      'level_copper',
      'level_silver',
      'level_gold',
      'profile',
      'showsData',
      'seasonsData',
    ]),
    ...mapGetters('show', [
      'currentSeason',
    ]),
    ...mapGetters('game', [
      'gameOn'
    ]),

    newbie: function() {
      if(this.profile.datas.points === 0) {
        return true
      }
      return false
    },

    totalEpisodes: function () {
      return this.profile.datas.total_episodes;
    },
    totalDuration:function() {
      return this.profile.datas.total_duration;
    },

    wordsLoaded: {
      get: function() {
        return this.loaded;
      },
      set(value) {
        this.loaded = value;
      }
    },

    isGold: {
      get: function() {
        return this.gold
      },
      set: function(value) {
        this.gold = value
      }
    },

    isSilver: {
      get: function() {
        return this.silver
      },
      set: function(value) {
        this.silver = value
      }
    },

    isBronze: {
      get: function() {
        return this.bronze
      },
      set: function(value) {
        this.bronze = value
      }
    },

    isNewest: {
      get: function() {
        return this.newest
      },
      set: function(value) {
        this.newest = value
      }
    },

    filteredWords: function() {
      this.fullWordsLearnt.forEach((word, index) => {
        if(word.user_lemma[0].last_studied === null) {
        }
      })
      if(this.newest) {
        return this.fullWordsLearnt.slice().sort(function(a, b) {
          return b.user_lemma[0].last_studied.localeCompare(a.user_lemma[0].last_studied)
        })
      }

      return this.fullWordsLearnt;
    },
    mainLevel:function(){
      if (this.profile.datas.points != null){
        return Math.floor(-10+Math.sqrt((this.profile.datas.points+5)+500)/Math.sqrt(5))
      }
      else {
        return 0
      }
    },
    percentsCompleted:function(){
      return 1-(this.pointToLevelUp / (Math.floor(5*Math.pow((this.mainLevel+1),2)+100*(this.mainLevel+1))-Math.floor(5*Math.pow(this.mainLevel,2)+100*this.mainLevel)))
    },
    pointToLevelUp:function(){
      if (this.profile.datas.points != null){
        return Math.floor(5*Math.pow((this.mainLevel+1),2)+100*(this.mainLevel+1)) - this.profile.datas.points-5
      }
      else {
        return 100
      }
    },
  },
/*
    filteredWords: function() {
      let list = [];
      if(!this.isGold && !this.isSilver && !this.isBronze) {
        return this.fullWordsLearnt
      }
      if(this.gold) {
        list = list.concat(this.byStar(this.fullWordsLearnt, 'gold'))
      }
      if(this.silver) {
        list = list.concat(this.byStar(this.fullWordsLearnt, 'silver'))
      }
      if(this.bronze) {
        list = list.concat(this.byStar(this.fullWordsLearnt, 'bronze'))
      }
      if(this.newest) {
        list.sort(function(a, b) {
          return b.user_lemma[0].last_studied.localeCompare(a.user_lemma[0].last_studied)
        })
      }

      return list;
    }
  },
*/

  methods: {
    ...mapActions('global', [
      'set_fullWordsLearnt',
        'set_navOpened'
    ]),
    ...mapActions('show', [
      'set_currentSeason',
        'set_seasonRequested'
    ]),
    ...mapActions('game', [
      'set_gameOn',
      'set_gameWordsList',
      'set_gameWordsListLoaded',
      'set_gameOrigin'
    ]),

    styleObject: function(season) {
      return {
        '--hue': season.hue
      }
    },
    loadFullWordsLearnt: function () {
      let token = 0
      this.$webAuth.checkSession({}, (error, authResult) => {
        try {
          token = authResult.accessToken;
        } catch (e) {
          console.error(e)
        }

        let url = `${API_URL}/api/full_words_learnt/`
        axios.get(url, {headers: {Authorization: `Bearer ${token}`}})
            .then(response => {
              return response.data;
            })
            .then(data => {
                  this.set_fullWordsLearnt(data)
                  this.wordsLoaded = true;
                }
            );
      })
    },
    getHours: function(duration){
      return Math.floor(Math.round(duration)/60)
    },
    getMinutes: function(duration){
      return Math.round(duration)-this.getHours(duration)*60
    },
    byStar(words, star) {
      let level = -1;
      if(star === 'gold') {
        level = 3;
      }
      else if(star === 'silver') {
        level = 2;
      }
      else {
        level = 1;
      }
      return words.filter(element => {
        return element.user_lemma[0].knowledge_level === level
      })
    },

    setGame(wordsList) {
      this.set_gameWordsList(wordsList);
      this.set_gameWordsListLoaded(true);
      this.set_gameOn(true);
      this.set_gameOrigin("progression")
    },

    getBackground: function (show_poster_path) {
      if (show_poster_path !== null) {
        return 'url(https://learnandwatch.s3.eu-west-3.amazonaws.com/small/' + show_poster_path + '), url(' + require('../assets/placeholder.png') + ')';
      } else {
        return ''
      }
    },
    getBackgroundBlur: function (show_background_path) {
      if (show_background_path !== null) {
        return 'https://learnandwatch.s3.eu-west-3.amazonaws.com/blur3/' + show_background_path ;
      } else {
        return ''
      }
    },
    selected: function (val) {
      this.$emit('selected', val);
    },
  },

  data() {
    return {
      loaded: false,
      gold: true,
      silver: true,
      bronze: true,
      newest: true,
    }
  }

}
</script>

<style scoped>
  h2{
    margin-bottom: 0.5vw;
  }
  #progressionBody{
    overflow: auto;
    width: calc(100% - 2vw);
    max-width: calc(100% - 2vw);
    min-width: calc(100% - 2vw);
    /*width: calc(100% - 2vw);*/
    height: calc(100% - 3vw);
    max-height: 100%;
    /*height: calc(100% - 2vw);*/
    display: flex;
    flex-direction: column;
    padding: 3vw 1vw 0 1vw;
    color: var(--goalColor);
    align-content: center;
  }

  #progressionHead{
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: auto auto;
    grid-gap: 0.5vw;
    justify-self: center;
    align-items: center;

    padding-right: 0.5vw;
  }

  .progressionBubble{
    flex-direction: column;
    width: 3vw;
    height: 3vw;
    margin-right: 0.5vw;
    border-radius: 4vw;
    text-align: center;
    font-weight: bold;
    padding: 0.5vw;
  }

  .poster{
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
  }

  .bubble2{
    width: 2vw;
    height: 2vw;
  }

  .progressionLevels{
    width: 3vw;
    margin: 0.1vw 0 0.1vw 0;
    border-radius: 4vw;
    text-align: center;
    font-weight: bold;
    padding: 0.1vw 0 0.1vw 0;
  }

  #progressionOngoing{
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  #progressionOngoingBody{
    height: 8vw;
    width: fit-content;
    overflow: hidden;
    justify-self: center;
  }

  .currentShowColor {
    --lightColor: hsla(var(--hue), 100%, 96%, 1);
    --lightplainColor: hsla(var(--hue), 100%, 70%, 1);
    --darkColor: hsla(var(--hue), 100%, 5%, 1);
    --plainColor: hsla(var(--hue), 80%, 30%, 1);
    --lightGrey: hsla(var(--hue), 10%, 80%, 1);
  }

  .paddingLeft{
    margin-left: 1vw;
  }

  #profilepic {
    position: relative;
    width: 4.5vw;
    height: 4.5vw;
    border-radius: 5vw;
    /*border: #6A3805 0.1vw solid;*/
    background-position: center;
    background-size: contain;
    border: 0.2vw hsl(200, 20%, 10%) solid;
  }

  #premiumIconProgression{
    position: absolute;
    right: -0.1vw;
    top: -0.1vw;
    border-radius: 1.4vw;
    height: 1.4vw;
    width: 1.4vw;
    font-size: 0.8em;
    color: #ffda7b;
    background-color: hsl(200, 20%, 10%);
    margin-right: -2px;
  }

  .vignettecontent{
    background-color: hsla(var(--hue), 100%, 20%, 0.3);
    color: var(--lightColor);
    padding: 1vw;
    align-items: center;
    align-content: center;
    height: 100%;
    min-height:  6vw;

  }



  .progressionStats{
    position: relative;
    height: calc(100% - 3vw);
    width: calc(100%-2vw);
    margin-right: auto;
    margin-left: auto;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto 1fr;
    grid-row-gap: 2vw;
    padding: 1.5vw 1vw 1.5vw 1vw;
  }

  .isActive {
    font-weight: bold;
  }

  .words {
    height: 90%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .wordsList {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;
    overflow: auto;
  }

  .wordsColor {
    width: 33%;
    overflow: hidden;
  }

  #othershow{
    justify-self: flex-end;
    margin-bottom: 2vw;
  }

  @media screen and (max-device-width: 767px) {

    #progressionBody{
      overflow: auto;
      width: calc(100% - 10vw);
      max-width: calc(100% - 10vw);
      min-width: calc(100% - 10vw);
      /*width: calc(100% - 2vw);*/
      height: calc(100% - 10vw);
      max-height: calc(100% - 10vw);
      /*height: calc(100% - 2vw);*/
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      padding: 5vw;

    }

    .progressionStats{
      max-height: calc(100% - 10vw);
      height: calc(100% - 10vw);
      width: auto;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: auto auto auto 1fr;
      grid-row-gap: 6vw;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 5vw;
    }

    #progressionHead{
      grid-column: 1/2;
      padding-right: 0;
    }

    #profilepic {
      width: 12vw;
      height: 12vw;
      border-radius: 12vw;
      border: 1vw hsl(200, 20%, 10%) solid;
    }

    #premiumIconProgression{
      position: absolute;
      right: -0.8vw;
      top: -0.4vw;
      border-radius: 4vw;
      height: 5vw;
      width: 5vw;
      font-size: 0.8em;
    }

    .progressionBubble{
      width: 15vw;
      height: 15vw;
      margin-right: 1vw;
      margin-left: 1vw;
      border-radius: 12vw;
      padding: 2vw;
    }

    .bubble2{
      width: 10vw;
      height: 10vw;
      padding: 1.5vw;
    }

    .progressionLevels{
      width: 12vw;
      margin: 0.5vw 0.5vw 0.5vw 1vw;
      border-radius: 12vw;
      padding: 0.5vw;
    }

    .vignettecontent{
      height: 24vw;
      display: grid;
      grid-template-columns: auto auto;
      grid-template-rows: auto 1fr;
      grid-column-gap: 2vw;
      padding: 3vw;
    }

    #progressionOngoing{
      width: 100%;
    }
    #progressionOngoingBody{
      height: 30vw;
      width: 100%;
    }

    .words {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }

    .wordsColor {
      height: 33%;
      width: auto;
    }

    .wordsList {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    ::-webkit-scrollbar {
      width: 1vw;
      height: 0.35vw;
    }
  }
</style>
